import React, { FC, createContext, useState, useEffect, useContext } from 'react';
import { CookieConsentBanner }                                       from "../components/cookie-consent-banner";

export type CookieCategoryType = 'required' | 'preferences' | 'statistics' | 'marketing';
export type CookieLifeTimeType = 'duration' | 'persistent' | 'session';
export type CookieIncludeType = 'http' | 'pixel';
export type CookieStorageType = 'localstorage' | 'cookie';

export interface CookieInfo<Key extends string = any> {
    key: Key;
    category: CookieCategoryType;
    vendor: string;
    vendorUrl: string;
    purpose: string;
    lifetime: CookieLifeTimeType;
    includeType: CookieIncludeType;
    storageType: CookieStorageType;
}

export type CookieInfoMap<T extends string> = {
    [id in T]: CookieInfo<id>;
}

export interface ConsentContextType {

}

export const ConsentContext = createContext<ConsentContextType>( {} );

export const useCreateConsent = (): ConsentContextType => {
    const [ context, setContext ] = useState<ConsentContextType>( {} );

    return context;
}

export const useConsent = (): ConsentContextType => {
    return useContext( ConsentContext );
}

export interface ConsentProviderProps {

}

export const ConsentProvider: FC<ConsentProviderProps> = ( { children } ) => {
    const contextValue = useCreateConsent();

    return (
        <ConsentContext.Provider value={ contextValue }>
            { children }
            <CookieConsentBanner/>
        </ConsentContext.Provider>
    )
}